module.exports = __webpack_public_path__ + "img/loading.808db712.gif";